import { render, staticRenderFns } from "./chat-message.vue?vue&type=template&id=c9ed6814&scoped=true&"
import script from "./chat-message.vue?vue&type=script&lang=js&"
export * from "./chat-message.vue?vue&type=script&lang=js&"
import style0 from "./chat-message.vue?vue&type=style&index=0&id=c9ed6814&lang=sass&scoped=true&"
import style1 from "./chat-message.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ed6814",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9ed6814')) {
      api.createRecord('c9ed6814', component.options)
    } else {
      api.reload('c9ed6814', component.options)
    }
    module.hot.accept("./chat-message.vue?vue&type=template&id=c9ed6814&scoped=true&", function () {
      api.rerender('c9ed6814', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/atendimento/components/chat-message/chat-message.vue"
export default component.exports